import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAppContext } from "@context/AppContext";

/**
 * Building a report is the entry point for both hub sections — templates are
 * saved from the builder, and snapshots are saved from a run — so this sits
 * at the top of each list rather than on one of them.
 */
const NewGeneralReportButton: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { checkPermissions } = useAppContext();

  if (!checkPermissions(["GenerateReports"])) return null;

  return (
    <Link
      to="/polestar/reports/adhoc/new"
      className="btn-secondary text-sm rounded whitespace-nowrap"
    >
      {t("reporting.new_general_report")}
    </Link>
  );
};

export default NewGeneralReportButton;
